// Phase 7 D3 — Track C T-C3. /settings/theme page.
//
// Two sections: Theme (radio group) and Timezone (combobox). Each writes
// independently — theme via PATCH /api/users/me/preferences { theme }
// (Q-9: server-backed; cookie hint covers first-paint), timezone via
// PATCH /api/users/me/timezone { timezone }.
//
// `usePreferences()` is mounted here (and on /settings/notifications) so
// the cache stays warm — ThemeSync uses the same query key to mirror the
// server's value into the in-memory ThemeProvider state.

import * as React from 'react';
import { copy } from '@dailydeck/shared/copy';
import { usePreferences } from '../../../hooks/usePreferences.js';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui/Card.js';
import { ThemeRadioGroup } from './ThemeRadioGroup.js';
import { TimezonePicker } from './TimezonePicker.js';

export function Theme(): JSX.Element {
  React.useEffect(() => {
    document.title = `DailyDeck — ${copy.settings.shell.nav.theme}`;
  }, []);

  // Mount the preferences fetch here so ThemeSync (top of the authed
  // shell) has data to reconcile against. The data is otherwise unused
  // by this page's render path — the ThemeRadioGroup reads from
  // useTheme() directly.
  usePreferences();

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h2
          id="settings-section-heading"
          className="text-title-2 font-semibold text-text-primary"
        >
          {copy.settings.theme.title}
        </h2>
        <p className="text-body text-text-secondary mt-1">
          {copy.settings.theme.description}
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>{copy.settings.theme.radioLegend}</CardTitle>
        </CardHeader>
        <CardContent>
          <ThemeRadioGroup />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{copy.settings.theme.timezoneSectionTitle}</CardTitle>
          <CardDescription>{copy.settings.theme.timezoneDescription}</CardDescription>
        </CardHeader>
        <CardContent>
          <TimezonePicker value={null} />
        </CardContent>
      </Card>
    </div>
  );
}
